import React from 'react'
import { Link } from 'react-router-dom'

function SmallLinkButton({ children, ...rest }) {
    return (
        <Link {...rest}
            className={`size-11 rounded-full shadow-lg bg-white text-black
      flex justify-center items-center hover:bg-black hover:text-white`}>
            {children}
        </Link>
    )
}

export default SmallLinkButton